// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__OfVm5","teacherInfo":"dashboard_teacherInfo__sikGj","features":"dashboard_features__yRK0K"};